// New Zealand Regions
export const NZ_REGIONS = [
  'Northland',
  'Auckland',
  'Waikato',
  'Bay of Plenty',
  'Gisborne',
  'Hawkes Bay',
  'Taranaki',
  'Manawatu-Whanganui',
  'Wellington',
  'Tasman',
  'Nelson',
  'Marlborough',
  'West Coast',
  'Canterbury',
  'Otago',
  'Southland',
] as const

export type NZRegion = typeof NZ_REGIONS[number]

// Admin emails
export const ADMIN_EMAILS = [
  'admin@isqroll.co.nz',
  'joel@temperocreative.co.nz',
  'demo@isqroll.co.nz',
]

// Demo credentials
export const DEMO_CREDENTIALS = {
  email: 'demo@isqroll.co.nz',
  password: 'demo123',
}
